import { loginModalIframe2 } from './login-modal.js'

let iOS

if (!SSR_MODE) {
  iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

const returnUrl = window.location.origin + '/inloggning/loginIframeModal.html?nospinner'
let currentLoginModal = null

function createLoginUrl (url, params) {
  const query = Object.keys(params)
    .map(name => {
      const value = encodeURIComponent(params[name])
      return `${name}=${value}`
    })
    .join('&')

  return `${url}?${query}`
}

function openLoginModal2 (loginUrl, opts = {}) {
  const container = document.querySelector('.iframe-modal-container')
  const url = createLoginUrl(loginUrl, {
    returnurl: returnUrl,
    initiator: 'icase',
    for_origin: window.location.origin
  })
  const { onClose = f => f } = opts

  if (currentLoginModal) {
    currentLoginModal.close()
  }

  currentLoginModal = loginModalIframe2(container, 'Logga in', url, {
    onClose: () => {
      currentLoginModal = null
      onClose()
    },
    onMessage: e => {
      // on success
      if (e.data === 'loginSuccessInIframe') {
        const NO_CONTENT = '204 NO_CONTENT'
        fetch('/api/user/authentication-type')
          .then(response => {
            if (response.status === 200) {
              return response.json()
            } else if (response.status === 204) {
              return NO_CONTENT
            } else {
              throw new Error('/api/user/authentication-type was unaccessible')
            }
          })
          .then(loginMethod => {
            if (loginMethod !== NO_CONTENT) {
              window.dataLayer.push({
                event: 'loginSuccess',
                loginMethod
              })
            }
          })
          .then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 500)
          })
          .catch(error => {
            console.error(error) // New Relic?
            setTimeout(() => {
              window.location.reload()
            }, 500)
          })
      }

      const { action, data } = e.data

      if (action === 'navigate-to-url') {
        window.location = data
      }

      if (action === 'restart-login') {
        openLoginModal2(loginUrl, opts)
      }

      if (action === 'cookies-allowed' && !data) {
        navigateToLogin(loginUrl)
      }
    }
  })

  return currentLoginModal
}

function openLogin (url, opts) {
  url = url.replace(/\/$/, '')
  openLoginModal2(url, opts)
}

function encodeLoginAndReturnUrl (loginUrl) {
  const encodedUrl = encodeURIComponent(window.location.href)
  return `${loginUrl}?returnurl=${encodedUrl}`
}

document.addEventListener('DOMContentLoaded', () => {
  // on dynamic content load we want to find js-login-modal link by using mutation observers
  const onLinkClick = e => {
    const url = e.currentTarget.href
    e.preventDefault()
    openLogin(url)
  }
  if (!SSR_MODE) {
    let observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        let loginModalLinks = mutation.target.querySelectorAll('.js-login-modal-iframe:not(.js-login-modal-initiated)')
        if (loginModalLinks.length > 0) {
          [...loginModalLinks].forEach(link => {
            if (link) {
              if (iOS) {
                // we send user to login page if ios device due to issue with bankid which does not allow user to open bankid in the same device inside iframe.
                link.href = encodeLoginAndReturnUrl(link.href)
                link.classList.remove('js-login-modal-iframe')
              } else {
                link.addEventListener('click', onLinkClick)
              }

              link.classList.add('js-login-modal-initiated')
            }
          })
        }
      })
    })
    let observerConfig = {
      childList: true,
      attributes: false,
      subtree: false
    }

    // observe on body
    observer.observe(document.body, observerConfig)
  }
})

function navigateToLogin (loginUrl) {
  window.location = encodeLoginAndReturnUrl(loginUrl)
}

window.forceUserLogin = (loginUrl, onClose) => {
  console.warn("forceUserLogin for IE11. If this log is seen report to content")
  if (iOS) {
    navigateToLogin(loginUrl)
  } else {
    return openLogin(loginUrl, {
      onClose
    })
  }
}
